define.alias("ember-truth-helpers/helpers/is-empty", "calendar/helpers/is-empty");